import { create } from "zustand";

export interface OrgInfo {
  id: string;
  name: string;
  plan: string | null;
  created_at: string;
  updated_at: string;
}

export type ManagementContext =
  | { type: "system" }
  | { type: "org"; org: OrgInfo };

interface ManagementState {
  context: ManagementContext | null;
  orgs: OrgInfo[];
  permissions: string[];
  setContext: (ctx: ManagementContext) => void;
  setOrgs: (orgs: OrgInfo[]) => void;
  setPermissions: (perms: string[]) => void;
  hasPermission: (perm: string) => boolean;
}

export const useManagementStore = create<ManagementState>((set, get) => ({
  context: null,
  orgs: [],
  permissions: [],
  setContext: (context) => set({ context }),
  setOrgs: (orgs) => set({ orgs }),
  setPermissions: (permissions) => set({ permissions }),
  hasPermission: (perm) => get().permissions.includes(perm),
}));
